// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc, increment, collection } from "firebase/firestore"; 


const firebaseConfig = {
    apiKey: "AIzaSyCGQRTz0XgRWI52CvnZkmtseiE9O_6oSes",
    authDomain: "pojobox-3d.firebaseapp.com",
    projectId: "pojobox-3d",
    storageBucket: "pojobox-3d.firebasestorage.app",
    messagingSenderId: "25339936711",
    appId: "1:25339936711:web:06de488b4dd2a7127663e2"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); // Inicializar Firebase Auth

export { db, doc, getDoc, setDoc, increment, collection, auth, createUserWithEmailAndPassword, signInWithEmailAndPassword };
